import type { FC } from 'react'

import styled from '@emotion/styled'

import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

interface HeroProp {
  title: string
  description: string
  courseNumber: number
  lessonNumber: number
}

const Hero: FC<HeroProp> = ({ title, description, courseNumber, lessonNumber }) => {
  return (
    <Wrapper>
      <StyledHero variant="centered">
        <HeroRecipe.Copy>
          <StyledCopy>
            <CopyText.Overline>
              <Uppercase>Course</Uppercase> {courseNumber} • Lesson {lessonNumber}
            </CopyText.Overline>
            <CopyText.Heading tag="h1" variant="h2">
              {title}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pExtraLarge">
              {description}
            </CopyText.Description>
          </StyledCopy>
        </HeroRecipe.Copy>
      </StyledHero>
    </Wrapper>
  )
}

export default Hero

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const Uppercase = styled.span`
  text-transform: uppercase;
`

const StyledCopy = styled(CopyTextBase)`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    text-align: center;
  }
`

const StyledHero = styled(HeroRecipeBase)`
  ${HeroRecipe.Wrapper} {
    gap: 0;
  }
`
